const dictation = [
    {
        path: '/dictation/home',
        name: 'dictationHome',
        component: resolve => require(['@/view/dictation/home/home'], resolve),
        meta: {
            title: '听写跟读',
            keepAlive: true
        }
    },
    {
        path: '/dictation/american',
        name: 'american',
        component: resolve => require(['@/view/dictation/american/index'], resolve),
        meta: {
            title: '科学美国人(SSS)',
            keepAlive: true
        }
    },
    {
        path: '/dictation/detail',
        name: 'american',
        component: resolve => require(['@/view/dictation/detail/index'], resolve),
        meta: {
            title: '科学美国人(SSS)',
            keepAlive: true
        }
    },
    {
        path: '/dictation/user/index',
        redirect: '/dictation/user/profile/home',
        name: 'userHome',
        component: resolve => require(['@/view/dictation/user/Index'], resolve),
        meta: {
            title: '个人中心',
            keepAlive: true
        },
        children: [
            {
                path: '/dictation/user/profile/home',
                name: 'userProfile',
                component: resolve => require(['@/view/dictation/user/profile/Home'], resolve),
                meta: {
                    title: '个人主页',
                    keepAlive: true
                }
            },
            {
                path: '/dictation/user/profile/changePwd',
                name: 'changePwd',
                component: resolve => require(['@/view/toefl/user/profile/changePwd'], resolve),
                meta: {
                    title: '修改密码',
                    keepAlive: true
                }
            },
            {
                path: '/dictation/user/collection/album',
                name: 'album',
                component: resolve => require(['@/view/dictation/user/collection/album'], resolve),
                meta: {
                    title: '专辑收藏',
                    keepAlive: true
                }
            },
            {
                path: '/dictation/user/collection/record',
                name: 'record',
                component: resolve => require(['@/view/dictation/user/collection/record'], resolve),
                meta: {
                    title: '录音收藏',
                    keepAlive: true
                }
            },
            {
                path: '/dictation/user/collection/sentence',
                name: 'sentence',
                component: resolve => require(['@/view/dictation/user/collection/sentence'], resolve),
                meta: {
                    title: '句子收藏',
                    keepAlive: true
                }
            },
            {
                path: '/dictation/user/premium/dictationVip',
                name: '精听会员',
                component: resolve => require(['@/view/dictation/user/premium/dictationVip'], resolve),
                meta: {
                    title: '精听会员',
                    requireAuth: true
                }
            },
            {
                path: '/dictation/user/setting',
                name: '系统设置',
                component: resolve => require(["@/view/dictation/user/setting"], resolve),
                meta: {
                    title: '默认设置',
                    requireAuth: true
                }
            },
            {
                path: '/dictation/user/practice/listen',
                name: '精听记录',
                component: resolve => require(["@/view/dictation/user/practice/listen"], resolve),
                meta: {
                    title: '精听记录',
                    requireAuth: true
                }
            },
            {
                path: '/dictation/user/practice/analysis',
                name: '结构分析',
                component: resolve => require(["@/view/dictation/user/practice/analysis"], resolve),
                meta: {
                    title: '结构分析',
                    requireAuth: true
                }
            },
            {
                path: '/dictation/user/practice/repeat',
                name: '复述记录',
                component: resolve => require(["@/view/dictation/user/practice/repeat"], resolve),
                meta: {
                    title: '复述记录',
                    requireAuth: true
                }
            },
            {
                path: '/dictation/user/practice/dictation',
                name: '听写记录',
                component: resolve => require(["@/view/dictation/user/practice/dictation"], resolve),
                meta: {
                    title: '听写记录',
                    requireAuth: true
                }
            },
            {
                path: '/dictation/user/practice/followAlong',
                name: '跟读记录',
                component: resolve => require(["@/view/dictation/user/practice/followAlong"], resolve),
                meta: {
                    title: '跟读记录',
                    requireAuth: true
                }
            },
        ]
    },

]

export default dictation


// WEBPACK FOOTER //
// ./src/router/dictation/dictation.js